// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction2_wrapper__dOilj","button":"introduction2_button__n7IyS"};